function padNumber(value: number): string {
  return String(value).padStart(2, '0');
}

function formatDateStamp(date: Date): string {
  return `${date.getFullYear()}${padNumber(date.getMonth() + 1)}${padNumber(date.getDate())}`;
}

function buildRandomCode(length = 10): string {
  let code = '';

  while (code.length < length) {
    code += Math.random().toString(36).slice(2).toUpperCase();
  }

  return code.slice(0, length);
}

export function generateConversationRef(date = new Date()): string {
  return `LEAI-${formatDateStamp(date)}-${buildRandomCode()}`;
}
